import React from "react";
import "./heroimg.css";
import Logo from "./../../../Images/pricingimg1.png";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const pricingslogan = " Price is what you pay, Value is what you get. ";
const pricingsmalltext =
  // "Have your ever thought about the value you get in return on your deposits lying with your broker?";
  "Have you ever thought about the return you get after discounting all the charges?"

function Heroimg() {
    let navigate = useNavigate();
    const TermsCondition = () => {
        let path = `./../TermsCondition`;
        navigate(path, { state: { plan: "terms" } });
    };

  return (
    <>
    <div className="pricinghero_section">
      <Container>
        <Row className="align-items-center">
          <Col md={8}>
            <div className="col-12 pe-0 ps-0">
            <div className="pricinghero_text ">
                <h1 className="herotextColorHeading otro-blockquote"> {pricingslogan} <i> <br></br>- Warren Buffet</i> </h1>
                                  <h3>{pricingsmalltext} <br></br>  With Moneysukh, Get Free equity delivery & flat ₹ 20/order for intraday & F&O trades.<br></br> Or <br></br>
                                      
                                    <button className="btnheroIntrest" onClick={() => TermsCondition()} >Trade at flat ₹10 across all segments.</button>
                                  </h3>
            </div>
            </div>
           
            {/* <div className="col-12">
              <button className="price-Login-Button"> Sign Up </button>
            </div> */}
          </Col>
          <Col md={4}>
            <img src={Logo} className="img-fluid imgcenter" alt=" im-logo" />
          </Col>
          {/* <Col className="BottonPsace"> &nbsp; </Col> */}
        </Row>
      </Container>
      </div>
    </>
  );
}
export default Heroimg;
